import { EntityId } from "@jackfruit/common"
import { SagaIterator } from "redux-saga"
import { call, select } from "redux-saga/effects"
import { ImageRegionEntity } from "~/interfaces/entities/ImageRegion"
import { ProductPageEntity } from "~/interfaces/entities/ProductPage"
import { imageRegionsSelectors } from "../state/imageRegions"
import { RootState } from "../store"
import { getLineItemPages } from "./lineItems"

export function* getImageRegion(
  imageRegionId: EntityId
): SagaIterator<ImageRegionEntity> {
  const imageRegion: ImageRegionEntity = yield select((state: RootState) =>
    imageRegionsSelectors.selectById(state, imageRegionId)
  )

  return imageRegion
}

export function* getImageRegions(
  imageRegionIds: EntityId[]
): SagaIterator<ImageRegionEntity[]> {
  const imageRegions: ImageRegionEntity[] = yield select((state: RootState) =>
    imageRegionsSelectors.selectByIds(state, imageRegionIds)
  )

  return imageRegions
}

export function* getAllImageRegionsForLineItem(
  lineItemId: EntityId
): SagaIterator<ImageRegionEntity[]> {
  const productPages: ProductPageEntity[] = yield call(
    getLineItemPages,
    lineItemId
  )
  const allImageRegionIds: EntityId[] = productPages
    .map(page => page.imageRegionIds)
    .flat()

  const allImageRegions: ImageRegionEntity[] = yield call(
    getImageRegions,
    allImageRegionIds
  )

  return allImageRegions
}
